import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataServiceService } from "../data-service.service";

@Component({
  selector: "app-admin-dashboard",
  templateUrl: "./admin-dashboard.component.html",
  styleUrls: ["./admin-dashboard.component.scss"],
})
export class AdminDashboardComponent implements OnInit {
  isUserLoading: boolean = true;
  isCompanyLoading: boolean = true;
  totalUserCount: number = 0;
  totalCompanyCount: number = 0;
  constructor(
    private router: Router,
    private dataService: DataServiceService
  ) {}

  ngOnInit(): void {
    this.getTotalUserCount().then(() => {
      this.isUserLoading = false;
    });
    this.getTotalCompanyCount().then(() => {
      this.isCompanyLoading = false;
    });
  }

  showAllCompanies() {
    this.router.navigate(["/all-companies"]);
  }

  showAllUsers() {
    this.router.navigate(["/all-users"]);
  }

  async getTotalUserCount() {
    this.totalUserCount = await this.dataService.getTotalUserCount();
  }

  async getTotalCompanyCount() {
    this.totalCompanyCount = await this.dataService.getTotalCompanyCount();
  }
}
